import React from "react";
import {ReactSession} from "react-client-session";
import {Helpers} from "../config/Helpers";
import $ from "jquery";

class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',

            total_orders: '0',
            total_orders_values: '0',
            orders_active: '0',
            orders_active_values: '0',
            orders_finished: '0',
            orders_finished_values: '0',
            orders_waiting_to_send: '0'
        }
    }

    componentDidMount() {
        this.getSummary();
    }

    getSummary = () => {
        $(".loader-wrapper").css("display", "");
        Helpers.getVendorSummary(this.state.sessUserCode).then(res => {
            $(".loader-wrapper").css("display", "none");
            if(res && res.length > 0){
                const r = res[0];

                this.setState({
                    total_orders: r.total_orders,
                    total_orders_values: r.total_orders_values,
                    orders_active: r.orders_active,
                    orders_active_values: r.orders_active_values,
                    orders_finished: r.orders_finished,
                    orders_finished_values: r.orders_finished_values,
                    orders_waiting_to_send: r.orders_waiting_to_send
                });
            }
        })
    };

    renderCard = (col, bg, color, icon, title, value, note) => {
        return (
            <div className={col}>
                <div className="card card-body mb-4">
                    <article className="icontext">
                        <span className={'icon icon-sm rounded-circle bg-' + bg + '-light'}>
                            <i className={'text-' + color + ' material-icons md-' + icon}></i>
                        </span>
                        <div className="text">
                            <h6 className="mb-1 card-title">{title}</h6>
                            <span>{value}</span>
                            <span className="text-sm"> {note} </span>
                        </div>
                    </article>
                </div>
            </div>
        );
    };

    render() {
        return (
            <>
                <section className="content-main">
                    <div className="content-header">
                        <div>
                            <h2 className="content-title card-title">Dashboard</h2>
                            <p>Whole data about vendor business here</p>
                        </div>
                    </div>
                    <div className="row">
                        {this.renderCard('col-lg-3', 'primary', 'primary', 'shopping_basket', 'Total Orders', this.state.total_orders, 'All status include')}
                        {this.renderCard('col-lg-3', 'success', 'success', 'notifications_active', 'Orders Active', this.state.orders_active, 'Active orders only')}
                        {this.renderCard('col-lg-3', 'warning', 'warning', 'local_shipping', 'Waiting to Send', this.state.orders_waiting_to_send, 'Need to deliver product')}
                        {this.renderCard('col-lg-3', 'info', 'info', 'receipt', 'Order Finished', this.state.orders_finished, 'Payment received')}
                        {this.renderCard('col-lg-4', 'primary', 'primary', 'monetization_on', 'Total Orders Values', 'Rp ' + this.state.total_orders_values, 'All status include')}
                        {this.renderCard('col-lg-4', 'success', 'success', 'monetization_on', 'Orders Active Values', 'Rp ' + this.state.orders_active_values, 'Active orders only')}
                        {this.renderCard('col-lg-4', 'info', 'info', 'monetization_on', 'Order Finished Values', 'Rp ' + this.state.orders_finished_values, 'Payment received')}
                    </div>
                </section>
            </>
        );
    }
}

export default Dashboard;
